//basic
import React from 'react';
import 'react-native-gesture-handler';
//navigation
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { Pages } from './models/enums'
//redux
import { createStore } from 'redux';
import AllReducers from './reducers';
import { Provider } from 'react-redux';
//pages
import HomePage from './pages/home';
import RegionsPage from './pages/regions';

const Stack = createStackNavigator();
const store = createStore(AllReducers);

export default function App() {
  return (
    <Provider store={store}>
      <NavigationContainer>
        <Stack.Navigator>
        <Stack.Screen
          name={Pages.home}
          component={HomePage}
          options={{ title: 'Расписание птичьих рынков' }}
        />
        <Stack.Screen
          name={Pages.regions}
          component={RegionsPage}
          options={{ title: 'Выбор региона' }}
        />
        </Stack.Navigator>
      </NavigationContainer>
    </Provider>
  );
}
